// Filter groups

const filtersGroup1 = {
  // includes_property_ownership: 'includes_property_ownership',
  price: ['priceType', 'price', 'exclude_private_negotiation', 'only_private_negotiation'],
  mq: 'mq',
  rooms: 'numRooms',
  baths: 'numBaths',
  numParkingSpaces: 'numParkingSpaces',
};

const filtersGroup2 = {
  level: 'level',
  lift: 'lift',
  // commercial_building_location: 'commercial_building_location',
  garden: 'garden',
  balconyAndTerrace: 'balconyAndTerrace',
  has_swimming_pool: 'has_swimming_pool',
  has_reception: 'has_reception',
};

const filtersGroup3 = {
  heatingType: 'heatingType',
  air_conditioned: 'air_conditioned',
  energyClass: 'energyClass',
};

const filtersGroup4 = {
  buildingCondition: 'buildingCondition',
  furniture: 'furniture',
  buildingYear: 'buildingYear',
  availability: 'availability',
  exclude_under_construction: 'exclude_under_construction',
  is_lux: 'is_lux',
  is_auction: 'is_auction',
};

const filtersGroup5 = {
  photo: 'photo',
  has_virtual_tour: 'has_virtual_tour',
  sellerType: 'sellerType',
  publication_date: 'publication_date',
};

export const filtersOrder = {
  // includes_property_ownership: 1,
  price: 2,
  mq: 3,
  rooms: 4,
  baths: 5,
  numParkingSpaces: 6,

  level: 7,
  lift: 8,
  // commercial_building_location: 9,
  garden: 10,
  balconyAndTerrace: 11,
  has_swimming_pool: 12,
  has_reception: 13,

  heatingType: 14,
  air_conditioned: 15,
  energyClass: 16,

  buildingCondition: 17,
  furniture: 18,
  buildingYear: 19,
  availability: 20,
  exclude_under_construction: 21,
  is_lux: 22,
  is_auction: 23,

  photo: 24,
  has_virtual_tour: 25,
  sellerType: 26,
  publication_date: 27,
};

export const filterBoxesConfiguration = {
  box1: filtersGroup1,
  box2: filtersGroup2,
  box3: filtersGroup3,
  box4: filtersGroup4,
  box5: filtersGroup5,
};

export const filterSections = {
  ...filtersGroup1,
  ...filtersGroup2,
  ...filtersGroup3,
  ...filtersGroup4,
  ...filtersGroup5,
};

export default filterSections;
